class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener(
      'keyup',
      (evt) => {
        if (evt.code === 'Escape') {
          this.close();
        }
      }
    );

    const overlay = this.querySelector(
      '#CartDrawer-Overlay'
    );

    if (overlay) {
      overlay.addEventListener(
        'click',
        this.close.bind(this)
      );
    }

    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector(
      '#cart-icon-bubble'
    );

    if (!cartLink) {
      console.warn(
        'GLOGLOBITOS: no se encontró #cart-icon-bubble'
      );

      return;
    }

    cartLink.setAttribute(
      'role',
      'button'
    );

    cartLink.setAttribute(
      'aria-haspopup',
      'dialog'
    );

    cartLink.addEventListener(
      'click',
      (event) => {
        event.preventDefault();

        this.open(cartLink);
      }
    );

    cartLink.addEventListener(
      'keydown',
      (event) => {
        if (
          event.code.toUpperCase() ===
          'SPACE'
        ) {
          event.preventDefault();

          this.open(cartLink);
        }
      }
    );
  }

  open(triggeredBy) {
    if (triggeredBy) {
      this.setActiveElement(
        triggeredBy
      );
    }

    const cartDrawerNote =
      this.querySelector(
        '[id^="Details-"] summary'
      );

    if (
      cartDrawerNote &&
      !cartDrawerNote.hasAttribute('role')
    ) {
      this.setSummaryAccessibility(
        cartDrawerNote
      );
    }

    setTimeout(() => {
      this.classList.add(
        'animate',
        'active'
      );
    }, 10);

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn =
          this.classList.contains('is-empty')
            ? this.querySelector(
                '.drawer__inner-empty'
              )
            : document.getElementById(
                'CartDrawer'
              );

        const focusElement =
          this.querySelector(
            '.drawer__inner'
          ) ||
          this.querySelector(
            '.drawer__close'
          );

        if (
          containerToTrapFocusOn &&
          focusElement &&
          typeof trapFocus ===
            'function'
        ) {
          trapFocus(
            containerToTrapFocusOn,
            focusElement
          );
        }
      },
      {
        once: true,
      }
    );

    document.body.classList.add(
      'overflow-hidden'
    );
  }

  close() {
    this.classList.remove(
      'active'
    );

    if (
      typeof removeTrapFocus ===
      'function'
    ) {
      removeTrapFocus(
        this.activeElement
      );
    }

    document.body.classList.remove(
      'overflow-hidden'
    );
  }

  setSummaryAccessibility(
    cartDrawerNote
  ) {
    cartDrawerNote.setAttribute(
      'role',
      'button'
    );

    cartDrawerNote.setAttribute(
      'aria-expanded',
      'false'
    );

    if (
      cartDrawerNote.nextElementSibling &&
      cartDrawerNote.nextElementSibling.getAttribute(
        'id'
      )
    ) {
      cartDrawerNote.setAttribute(
        'aria-controls',
        cartDrawerNote.nextElementSibling.id
      );
    }

    cartDrawerNote.addEventListener(
      'click',
      (event) => {
        const details =
          event.currentTarget.closest(
            'details'
          );

        if (!details) return;

        event.currentTarget.setAttribute(
          'aria-expanded',
          !details.hasAttribute('open')
        );
      }
    );

    if (
      typeof onKeyUpEscape ===
      'function'
    ) {
      cartDrawerNote.parentElement.addEventListener(
        'keyup',
        onKeyUpEscape
      );
    }
  }

  renderContents(parsedState) {
    console.log(
      'GLOGLOBITOS: renderizando carrito',
      parsedState
    );

    if (
      !parsedState ||
      !parsedState.sections
    ) {
      console.error(
        'GLOGLOBITOS: Shopify no devolvió las secciones del carrito',
        parsedState
      );

      return;
    }

    const drawerInner =
      this.querySelector(
        '.drawer__inner'
      );

    if (!drawerInner) {
      console.error(
        'GLOGLOBITOS: no se encontró .drawer__inner'
      );

      return;
    }

    /*
     * Quitar estado vacío
     */
    drawerInner.classList.remove(
      'is-empty'
    );

    this.classList.remove(
      'is-empty'
    );

    this.productId =
      parsedState.id;

    /*
     * ==========================================
     * ACTUALIZAR SECCIONES
     * ==========================================
     */

    this.getSectionsToRender().forEach(
      (section) => {

        const html =
          parsedState.sections[
            section.id
          ];

        if (!html) {
          console.warn(
            'GLOGLOBITOS: no llegó HTML para la sección:',
            section.id
          );

          return;
        }

        const sectionElement =
          section.selector
            ? document.querySelector(
                section.selector
              )
            : document.getElementById(
                section.id
              );

        if (!sectionElement) {
          console.warn(
            'GLOGLOBITOS: no se encontró elemento:',
            section.selector ||
              section.id
          );

          return;
        }

        try {
          const newHTML =
            this.getSectionInnerHTML(
              html,
              section.selector
            );

          if (
            newHTML &&
            newHTML.trim() !== ''
          ) {
            sectionElement.innerHTML =
              newHTML;

            console.log(
              'GLOGLOBITOS: sección actualizada:',
              section.id
            );
          } else {
            console.warn(
              'GLOGLOBITOS: HTML vacío para:',
              section.id
            );
          }

        } catch (error) {
          console.error(
            'GLOGLOBITOS: error actualizando sección:',
            section.id,
            error
          );
        }
      }
    );

    /*
     * ==========================================
     * REACTIVAR OVERLAY
     * ==========================================
     */

    setTimeout(() => {

      const newOverlay =
        this.querySelector(
          '#CartDrawer-Overlay'
        );

      if (newOverlay) {
        newOverlay.addEventListener(
          'click',
          this.close.bind(this)
        );
      }

      /*
       * Abrir carrito lateral
       */
      this.open();

      console.log(
        'GLOGLOBITOS: carrito lateral actualizado correctamente'
      );

    }, 50);
  }

  getSectionInnerHTML(
    html,
    selector = '.shopify-section'
  ) {
    const parser =
      new DOMParser();

    const doc =
      parser.parseFromString(
        html,
        'text/html'
      );

    /*
     * Primero intentamos encontrar
     * exactamente el selector solicitado.
     */
    const selected =
      selector
        ? doc.querySelector(
            selector
          )
        : null;

    if (selected) {
      return selected.innerHTML;
    }

    /*
     * Fallback para respuestas de Shopify
     * que ya contienen directamente
     * el contenido interno.
     */
    const shopifySection =
      doc.querySelector(
        '.shopify-section'
      );

    if (shopifySection) {
      return shopifySection.innerHTML;
    }

    /*
     * Último fallback:
     * devolver el body completo.
     */
    return doc.body.innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(
    html,
    selector = '.shopify-section'
  ) {
    const doc =
      new DOMParser().parseFromString(
        html,
        'text/html'
      );

    return doc.querySelector(
      selector
    );
  }

  setActiveElement(element) {
    this.activeElement =
      element;
  }
}


/*
 * ==========================================
 * DEFINICIÓN DEL CARRITO LATERAL
 * ==========================================
 */

if (
  !customElements.get(
    'cart-drawer'
  )
) {
  customElements.define(
    'cart-drawer',
    CartDrawer
  );
}


/*
 * ==========================================
 * ELEMENTOS DEL CARRITO
 * ==========================================
 */

if (
  typeof CartItems !==
  'undefined'
) {
  if (
    !customElements.get(
      'cart-drawer-items'
    )
  ) {
    class CartDrawerItems
      extends CartItems {

      getSectionsToRender() {
        return [
          {
            id: 'CartDrawer',
            section: 'cart-drawer',
            selector:
              '.drawer__inner',
          },
          {
            id: 'cart-icon-bubble',
            section:
              'cart-icon-bubble',
            selector:
              '.shopify-section',
          },
        ];
      }
    }

    customElements.define(
      'cart-drawer-items',
      CartDrawerItems
    );
  }
}